import { InjectionToken } from '@angular/core';
import { IAppConfig } from './app-config.interface';

export let APP_CONFIG = new InjectionToken<IAppConfig>('app.config');

export const APP_RECAPTCHA_KEY = '6Lcww1cUAAAAAH9eczzWwz8WhQkOJrQo5gF5lymj' ; // replaced '6LceblAUAAAAAAVu-e7ajinJgMzARB-ksOCU8wr9';

export const MANAGE_NOTIFICATION_PATH = '/manage-notifications';
export const MAX_LINKS_COUNT = '50';
export const APP_DI_CONFIG: IAppConfig = {
  urls: {
    office: {
      base: 'api/v1/office/',
      listings: 'api/v1/office/listings/',
      agents: 'api/v1/office/agents/',
      search: 'api/v1/office/search/',
      searchByDistance: 'api/v1/office/searchByDistance'
    },
    agent: {
      base: 'api/v1/agent/',
      listings: 'api/v1/agent/listings/',
      search: 'api/v1/agent/search/',
      filters: 'api/v1/agent/filters',
      count: 'api/v1/agent/count/',
      config: 'api/v1/agent/config/'
    },
    listings: {
      base: 'api/v1/listings/',
      active: 'api/v1/listings/active',
      detail: 'api/v1/listings/detail/',
      count: 'api/v1/listings/count',
      provinceCity: 'api/v1/listings/ca', // ex: ca/on/toronto
      preview: 'api/v1/listings/previews/',
      gallery: 'api/v1/listings/gallery/',
      search: 'api/v1/listings/search/',
      distance: 'api/v1/listings/distance',
      filters: 'api/v1/listings/filters'
    },
    schools: {
      base: 'api/v1/schools',
      preview: 'api/v1/schools/preview/',
    },
    user: {
      base: 'api/v1/user',
      login: 'api/v1/user/login',
      socialLogin: 'api/v1/user/login/social',
      logout: 'api/v1/user/logout',
      save: 'api/v1/user/save',
      accounts: 'api/v1/user/accounts',
      checkPasswordToken: 'api/v1/user/password/check-reset-link/',
      resetPassword: 'api/v1/user/password/reset',
      changePassword: 'api/v1/user/password/change',
      forgotPassword: 'api/v1/user/password/forgot',
      renewToken: 'api/v1/user/renew',
      restoreSession: 'api/v1/user/restoreSession',
      retrieveSavedSearch: 'api/v1/user/savedSearches',
      unsubscribeSavedSearchNotification: 'api/v1/user/unsubscribe'
    },
    mortgage: {
      base: 'api/v1/mortgage'
    },
    leads: {
      base: 'api/v1/leads'
    },
    blog: {
      base: 'api/v1/blog'
    },
    internalLinks: {
      base: 'api/v1/internalLinks'
    },
    homeEstimator: {
      base: 'api/v1/homeEstimation/bc',
      estimate: 'api/v1/homeEstimation/bc/estimate',
      suggestions: 'api/v1/homeEstimation/bc/findByAddress'
    },
    geo: {
      base: 'api/v1/geo'
    },
    demographics: {
      base: 'api/v1/demographics',
      point: 'api/v1/demographics/point',
      neighbourhoodPoint: 'api/v1/demographics/neighbourhood/point',
      neighbourhoodId: 'api/v1/demographics/neighbourhood/id',
    }
  }
};

export const victoriaRealEstate = 'victoria real estate';
export const OAAgentProvider = 'iFranchise-OA';
export const caraBoardPartialName = 'central alberta';
export const Luxury = 'luxury';
export const Commercial = 'commercial';
export const IndividualAgentAwards = 'agent-profile.awards.individual';
export const BritishColumbiaStateShort = 'BC';
